import { render, staticRenderFns } from "./AppBarContractLink.vue?vue&type=template&id=f4a189b4&scoped=true&"
import script from "./AppBarContractLink.vue?vue&type=script&lang=js&"
export * from "./AppBarContractLink.vue?vue&type=script&lang=js&"
import style0 from "./AppBarContractLink.vue?vue&type=style&index=0&id=f4a189b4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f4a189b4",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VChip } from 'vuetify/lib/components/VChip';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VChip,VIcon})
